import App from './app';

const internals = {
    initializers: [App],
};

export default (store) => {
    internals.initializers.forEach((init) => init(store));
};
